import cx from 'clsx';
import type { HTMLAttributes, ReactElement } from 'react';
import styles from '../popup.module.css';

export function PopupBody({
  className,
  children,
  ...props
}: HTMLAttributes<HTMLDivElement>): ReactElement {
  return (
    <div className={cx(styles.body, className)} data-testid="modal-body" {...props}>
      {children}
    </div>
  );
}
